import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
AOS.init();

const body = document.body;

const SubNavItems = document.querySelectorAll(
	'.header-navigation .menu-item--has-kids'
);
const delayTime = 200;
let subMenuDelay = false;
let seconds = 0;

SubNavItems.forEach((menu) => {
	menu.addEventListener('mouseenter', (event) => {
		subMenuDelay = setInterval(function () {
			seconds = seconds + 0.25;
			if (seconds == 0.25) {
				menu.classList.add('open');
				clearInterval(subMenuDelay);
				seconds = 0;
			}
		}, delayTime);
	});

	menu.addEventListener('mouseleave', (event) => {
		clearInterval(subMenuDelay);
		seconds = 0;
		setTimeout(() => {
			menu.classList.remove('open');
		}, delayTime);
	});
});

// burger / mobile navigation

const burger = document.querySelector('.burger');
const mobileNavigation = document.querySelector('.mobile-navigation');
if (burger) {
	burger.addEventListener('click', (event) => {
		event.preventDefault();
		burger.classList.toggle('active');
		document.querySelector('body').classList.toggle('nav-is-active');
		mobileNavigation.classList.toggle('active');
	});
}

const mobileNavigationParentMenuItems = mobileNavigation.querySelectorAll(
	'.mobile-navigation .menu-item-has-children'
);
if (mobileNavigationParentMenuItems) {
	mobileNavigationParentMenuItems.forEach((menuItem) => {
		let menuItemLink = menuItem.querySelector('a');
		let subMenu = menuItem.querySelector('.subnav');
		// console.log(subMenu);
		menuItemLink.addEventListener('click', (event) => {
			event.preventDefault();
			menuItem.classList.toggle('active');
			subMenu.classList.toggle('subnav--active');
		});
	});
}

// toggle menus
const toggleMenus = document.querySelectorAll('.toggleable-menu');
if (toggleMenus) {
	toggleMenus.forEach((toggleMenu) => {
		toggleMenu.addEventListener('click', (event) => {
			if (event.target.tagName != 'A') {
				event.preventDefault();
				toggleMenu.classList.toggle('active');
			}
		});
	});
}

let lastScroll = 0;

window.addEventListener('scroll', () => {
	const currentScroll = window.scrollY;
	if (currentScroll <= 0) {
		body.classList.remove('scroll-up');
		return;
	}

	if (currentScroll > lastScroll && !body.classList.contains('scroll-down')) {
		body.classList.remove('scroll-up');
		body.classList.add('scroll-down');
	} else if (
		currentScroll < lastScroll &&
		body.classList.contains('scroll-down')
	) {
		body.classList.remove('scroll-down');
		body.classList.add('scroll-up');
	}
	lastScroll = currentScroll;
});

const contrastSwitch = document.getElementById('contrast-switch');

// if no local storage for highContrast set it to false
if (localStorage.getItem('highContrast') === null) {
	localStorage.setItem('highContrast', 'false');
} else {
	// if highContrast is true add body class
	if (localStorage.getItem('highContrast') == 'true') {
		body.classList.add('high-contrast');
		contrastSwitch.checked = true;
	}
}

contrastSwitch.addEventListener('change', function () {
	if (contrastSwitch.checked == true) {
		body.classList.add('high-contrast');
		localStorage.setItem('highContrast', 'true');
	} else {
		body.classList.remove('high-contrast');
		localStorage.setItem('highContrast', 'false');
	}
});

function Marquee(selector, speed, direction) {
	// gets parent selector element
	const parentSelector = document.querySelector(selector);
	// makek a copy of its contents
	const clone = parentSelector.innerHTML;
	// mark the first element
	const firstElement = parentSelector.children[0];
	// i to 0 for later use
	let i = 0;
	// set place to empty
	let place = '';

	if (direction == 'rtl') {
		place = 'beforeend';
	}

	if (direction == 'ltr') {
		place = 'afterbegin';
		parentSelector.classList.add('marquee--ltr');
	}

	parentSelector.insertAdjacentHTML(place, clone);
	// parentSelector.insertAdjacentHTML(place, clone);

	setInterval(function () {
		if (direction == 'rtl') {
			firstElement.style.marginLeft = `-${i}px`;
		}
		if (direction == 'ltr') {
			firstElement.style.marginRight = `-${i}px`;
		}
		if (i > firstElement.clientWidth) {
			i = 0;
		}
		i = i + speed;
	}, 0);
}

Marquee('.marquee--1', 0.1, 'ltr');
Marquee('.marquee--2', 0.1, 'rtl');
document
	.querySelectorAll('.lvideo')
	.forEach((d) => d.addEventListener('click', playVideos));

function playVideos(e) {
	lvideo(e.currentTarget.dataset.url);

	body.classList.add('lvideo-active');

	var lvideoWrap = document.createElement('DIV');
	lvideoWrap.setAttribute('id', 'lvideo-wrap');
	document.body.appendChild(lvideoWrap);

	// console.log(this.dataset.url)
	// console.log(this.dataset.video)

	const wrapper = document.getElementById('lvideo-wrap');
	wrapper.classList.add('active');

	const url = this.dataset.url;

	const startModal = `<span class="lvideo-overlay"></span> <div class="lvideo-container">`;
	const finishModal = `</div><button class="lvideo-close">x</button>`;

	// if (url.indexOf("youtube") !== -1) {
	if (url.indexOf('youtube') !== -1 || url.indexOf('youtu') !== -1) {
		//console.log("is youtube")

		const ytUrl = [this.dataset.url];

		var i,
			r,
			regExp =
				/^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/;

		for (i = 0; i < ytUrl.length; ++i) {
			r = ytUrl[i].match(regExp);
			//console.log(r[1])

			document.getElementById(
				'lvideo-wrap'
			).innerHTML = `${startModal}<iframe width="560" height="315" title="YouTube Video" src='https://www.youtube.com/embed/${r[1]}?rel=0&autoplay=1&mute=1&loop=1&playlist=${r[1]}' frameborder="0" allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe>${finishModal}`;
		}
	} else if (url.indexOf('vimeo') !== -1) {
		// console.log("is Vimeo")

		const vimeoURL = this.dataset.url;
		const regExp = /https:\/\/(www\.)?vimeo.com\/(\d+)($|\/)/;

		const match = vimeoURL.match(regExp);

		if (match) {
			document.getElementById(
				'lvideo-wrap'
			).innerHTML = `${startModal}<iframe title="Vimeo" src="https://player.vimeo.com/video/${match[2]}?autoplay=1&loop=1" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>${finishModal}`;
		} else {
			alert('Not a Vimeo!  URL example:\n https://vimeo.com/120206922');
		}
	} else if (url.indexOf('mp4') !== -1 || url.indexOf('m4v') !== -1) {
		document.getElementById(
			'lvideo-wrap'
		).innerHTML = `${startModal}<video controls loop playsinline autoplay><source src='${this.dataset.url}' type="video/mp4"></video>${finishModal}`;
	} else {
		alert('No video link found.');
	}

	const closeModalButton = wrapper
		.querySelector('.lvideo-close')
		.addEventListener('click', lvideoClose);

	const closeModalBg = wrapper
		.querySelector('.lvideo-overlay')
		.addEventListener('click', lvideoClose);
}

// CLOSE MODAL LVIDEO
const lvideoClose = () => {
	body.classList.remove('lvideo-active');

	const wrapper = document.getElementById('lvideo-wrap');
	wrapper.parentNode.removeChild(wrapper);
};

// LAUNCH
function lvideo() {}

const supportTermTrigger = document.querySelectorAll('.support-term-trigger');
supportTermTrigger.forEach((trigger) => {
	let parentLi = trigger.parentNode;

	trigger.addEventListener('click', (e) => {
		parentLi.classList.toggle('support-terms__item--open');
	});
});

const accordionItems = document.querySelectorAll(
	'.faq-accordion__item .trigger'
);

accordionItems.forEach((item) => {
	item.addEventListener('click', () => {
		item.closest('.faq-accordion__item').classList.toggle('active');
		item.classList.toggle('h2');
	});
});

const allIframes = document.querySelectorAll('iframe');

if (allIframes) {
	allIframes.forEach((iframe) => {
		iframe.style.height =
			iframe.contentWindow.document.documentElement.scrollHeight + 'px';
	});
}

const mobileSearchTriggers = document.querySelectorAll(
	'.mobile-search-trigger'
);
const mobileSearchImput = document.querySelector('.mobile-search input');
mobileSearchTriggers.forEach((trigger) => {
	trigger.addEventListener('click', (e) => {
		body.classList.toggle('mobile-search-active');
		mobileSearchImput.focus();
	});
});

const footerNavTriggers = document.querySelectorAll(
	'.site-footer .col--nav h3'
);

footerNavTriggers.forEach((trigger) => {
	let navUL = trigger.nextElementSibling;
	trigger.addEventListener('click', (e) => {
		navUL.classList.toggle('active');
	});
});
